import React, { useState } from 'react';
import { TouchableOpacity, View, Text, StyleSheet } from 'react-native';
import Svg, { Path } from 'react-native-svg';
import { useTheme } from 'react-native-paper';

const CheckBox = ({ label, checked, onChange, disabled = false }) => {
  const { colors } = useTheme();

  return (
    <TouchableOpacity
      onPress={onChange}
      style={styles.container}
      disabled={disabled}
    >
      <Svg
        viewBox="0 0 24 24"
        width="22"
        height="22"
        fill={checked ? colors.primary : colors.secondaryText}
      >
        {checked ? (
          <Path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 14-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
        ) : (
          <Path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z" />
        )}
      </Svg>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    // alignItems: 'center',
  },
});

export default CheckBox;
